import { WorkerExpenseReportController } from "../../../controllers";
import { ComponentBase } from "../../_ComponentBase";

/**
 * Component for ExpenseReport usecase
 * @example
 * ```html
 * <salaxy-expense-report ng-if="$ctrl.current" parent="$ctrl.getMessage().contentData" report-type="$ctrl.current.usecase.data.protoId"></salaxy-expense-report>
 * ```
 */
export class ExpenseReport extends ComponentBase {

    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
     public bindings = WorkerExpenseReportController.bindings;

    /** Uses the WorkerExpenseReportController */
    public controller = WorkerExpenseReportController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/communications/messages/message-types/ExpenseReport.html";

}
